import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIcon2Cars = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={12}
    fill="none"
    viewBox="0 0 15 12"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#fff"
      fillOpacity={0.8}
      d="m.844 3.164.61-1.875C1.71.54 2.437 0 3.233 0h3.258c.797 0 1.524.54 1.781 1.29L8.836 3h-.352A2.618 2.618 0 0 0 6 4.805l-.54 1.593c-.14.118-.28.235-.397.352H1.874v.75c0 .422-.352.75-.75.75H.75A.74.74 0 0 1 0 7.5v-3c0-.586.328-1.102.844-1.336ZM2.46 3h4.805l-.422-1.242a.38.38 0 0 0-.352-.258H3.234a.38.38 0 0 0-.351.258L2.46 3Zm-.586 1.313a.555.555 0 0 0-.563.562c0 .328.235.563.563.563a.555.555 0 0 0 .563-.563.57.57 0 0 0-.563-.563Zm6.61-.563h3.257c.797 0 1.524.516 1.781 1.29l.61 1.874c.515.234.867.75.867 1.336v3c0 .422-.352.75-.75.75h-.375a.74.74 0 0 1-.75-.75v-.75h-6v.75c0 .422-.352.75-.75.75H6a.74.74 0 0 1-.75-.75v-3c0-.586.328-1.102.844-1.336l.61-1.875a1.886 1.886 0 0 1 1.78-1.289Zm0 1.5a.38.38 0 0 0-.352.258L7.71 6.75h4.805l-.422-1.242a.381.381 0 0 0-.352-.258H8.484Zm-1.36 3.938a.555.555 0 0 0 .563-.563.57.57 0 0 0-.563-.563.555.555 0 0 0-.563.563c0 .328.235.563.563.563Zm6-1.126a.555.555 0 0 0-.563.563c0 .328.235.563.563.563a.555.555 0 0 0 .563-.563.57.57 0 0 0-.563-.563Z"
    />
  </svg>
));
export default SvgIcon2Cars;
